import React from 'react'
import formatMessage from 'format-message'
import './CommentIndicator.css'

export default function CommentIndicator({ numberOfCommentsOutOfView, children }) {
  return (
    numberOfCommentsOutOfView > 0 && (
      <div className="CommentIndicator">
        <div className="ArrowIconContainer">{children}</div>
        <div className="CommentIndicator--text">
          {numberOfCommentsOutOfView > 1
            ? formatMessage('{numberOfComments} More Comments', {
                numberOfComments: numberOfCommentsOutOfView,
              })
            : formatMessage('1 More Comment')}
        </div>
      </div>
    )
  )
}
